import { useMutation } from '@tanstack/react-query';
import { getLesson } from '../queries/module';
import { useLessonStore } from '../stores/lessonStore';
import { useLessonContentStore } from '../stores/lessonContentStore';
import { useLessonRequestStore } from '../stores/lessonRequestStore';
import { ILesson } from '../models/lesson';

export function useLesson() {
  const setRequestLessons = useLessonRequestStore.getState().setLessons;
  const setLessons = useLessonStore.getState().setLessons;
  const setAllLessons = useLessonContentStore.getState().setAllLessons;
  
  const { mutate, isPending, isError } = useMutation({ 
    mutationKey: ['lesson'], 
    mutationFn: (module: string) => getLesson(module),
    retry: false,
    onSuccess: (result) => {
      setLessons(result);
      setAllLessons(result);
      setRequestLessons(result as ILesson[]);
    }
  });

  return { mutate, isPending, isError };
}
